let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("alntP")).then(() => parcelRequire('kNGCN'));